import { useAdjustedResidualInputProps } from '@makemydeal/dr-dash-components';

import { AdjResidualDisplayRow } from './AdjResidualDisplayRow';
import { AdjResidualFieldRow } from './AdjResidualFieldRow';

export const AdjResidualRow = () => {
    const { isReadOnlyDisplay, inputProps } = useAdjustedResidualInputProps();

    return isReadOnlyDisplay ? <AdjResidualDisplayRow /> : <AdjResidualFieldRow inputProps={inputProps} />;
};
